import { ReactComponent as EditIcon } from "@assets/icon/editIcon.svg";
import { ReactComponent as DeleteIcon } from "@assets/icon/deleteIcon.svg";
import { ReactComponent as UserAvatarIcon } from "@assets/icon/avatarIcon.svg";
import { ReactComponent as BookingIcon } from "@assets/icon/bookingIcon.svg";
import { ReactComponent as ClaimsIcon } from "@assets/icon/claimsIcon.svg";
import { ReactComponent as HomeIcon } from "@assets/icon/homeIcon.svg";
import { ReactComponent as UserManagementIcon } from "@assets/icon/userManagementIcon.svg";
import { ReactComponent as VoucherIcon } from "@assets/icon/voucherIcon.svg";
import { ReactComponent as LogoutIcon } from "@assets/icon/logoutIcon.svg";
import { ReactComponent as HamburgerIcon } from "@assets/icon/hamburgerIcon.svg";
import { ReactComponent as ArrowRight } from "@assets/icon/arrowRight.svg";
import { ReactComponent as DownloadIcon } from "@assets/icon/downloadIcon.svg";
import { ReactComponent as AgentIcon } from "@assets/icon/agentIcon.svg";
import { ReactComponent as ClaimsCardIcon } from "@assets/icon/claimsCardIcon.svg";
import { ReactComponent as BookingCardIcon } from "@assets/icon/bookingIcon.svg";
import { ReactComponent as TotalAmountIcon } from "@assets/icon/moneyIcon.svg";
import { ReactComponent as RefundIcon } from "@assets/icon/refundIcon.svg";
import { ReactComponent as ATPIcon } from "@assets/icon/atpContextCasesIcon.svg";
import { ReactComponent as ActiveStatus } from "@assets/icon/statusIcon.svg";
import { ReactComponent as ActiveIcon } from "@assets/icon/activeIcon.svg";
import { ReactComponent as ApprovalIcon } from "@assets/icon/approvalClaimIcon.svg";
import { ReactComponent as RejectionIcon } from "@assets/icon/rejectClaimsIcon.svg";
import { ReactComponent as ViewDetails } from "@assets/icon/viewDetails.svg";
import { ReactComponent as CloseCircle } from "@assets/icon/closeCircle.svg";
import { ReactComponent as ThreeDots } from "@assets/icon/threeDots.svg";
import { ReactComponent as UploadIcon } from "@assets/icon/uploadIcon.svg";
import { ReactComponent as AddUser } from "@assets/icon/addUser.svg";
import { ReactComponent as SettingsIcon } from "@assets/icon/settingsIcon.svg";
import { ReactComponent as EyeOpenIcon } from "@assets/icon/eyeOpenIcon.svg";
import { ReactComponent as EyeCloseIcon } from "@assets/icon/eyeCloseIcon.svg";
import { ReactComponent as RedeemAmount } from "@assets/icon/redeemAmount.svg";

export const ICON_MAP = {
  edit: EditIcon,
  delete: DeleteIcon,
  avatar: UserAvatarIcon,
  booking: BookingIcon,
  claims: ClaimsIcon,
  home: HomeIcon,
  userManagement: UserManagementIcon,
  voucher: VoucherIcon,
  logout: LogoutIcon,
  hamburger: HamburgerIcon,
  agent: AgentIcon,
  claimsCard: ClaimsCardIcon,
  bookingIcon: BookingCardIcon,
  refundIcon: RefundIcon,
  totalAmountIcon: TotalAmountIcon,
  atpContextCases: ATPIcon,
  activeStatus: ActiveStatus,
  newAssigned: ActiveIcon,
  arrowRight: ArrowRight,
  downlaodIcon: DownloadIcon,
  approvalIcon: ApprovalIcon,
  rejectIcon: RejectionIcon,
  viewIcon: ViewDetails,
  closeCircle: CloseCircle,
  threeDots: ThreeDots,
  uploadIcon: UploadIcon,
  addUser: AddUser,
  settingsIcon: SettingsIcon,
  eyeOpen: EyeOpenIcon,
  eyeClose: EyeCloseIcon,
  redeemAmount: RedeemAmount,
};
